import { useSelector } from 'react-redux'

// Components
import { IconDisc } from '@tracklib/kit'
import { Select } from 'components/form'

// Selectors
import { selectLatestLicenseVersion } from 'modules/licensing/selectors'
import { licenseTypesEntities, licenseRevenuesEntities } from 'selectors'

// Types
import { LicenseVersionWithLicenseTypes, EntityState, LicenseRevenue, LicenseType, State } from 'types'

import styles from './selectsamplelength.css'

type SampleLengthIconProps = {
  maxSeconds: number
}
export const SampleLengthIcon = ({ maxSeconds }: SampleLengthIconProps): JSX.Element => {
  return (
    <div className={styles.icon}>
      <div className={styles.maxSeconds}>{maxSeconds}</div>
      <IconDisc />
    </div>
  )
}
type SelectSampleLengthProps = {
  category: number
  name: string
}

const SelectSampleLength = ({ name, category }: SelectSampleLengthProps): JSX.Element => {
  const licenseRevenues = useSelector<State, EntityState<LicenseRevenue>>(state => licenseRevenuesEntities(state))
  const licenseTypes = useSelector<State, EntityState<LicenseType>>(state => licenseTypesEntities(state))
  const latestLicenseVersion = useSelector<State, LicenseVersionWithLicenseTypes>(state => selectLatestLicenseVersion(state))
  const renderLicenseReveue = (typeId: number) => {
    const licenseRevenueList = Object.keys(licenseRevenues).map(id => licenseRevenues[id])
    return licenseRevenueList.find(r => r.category === category && r.sample_type === typeId)?.share_percentage
  }

  if (!licenseTypes) {
    return <div />
  }

  return (
    <Select
      name={name}
      custom
      label="How much of the original song did you sample?"
      description="The sample length is cumulative–it doesn’t have to be a continuous piece."
    >
      {latestLicenseVersion.sample_types
        .sort((a, b) => a.ordering - b.ordering)
        .map((licenseType: LicenseType) => {
          const { id } = licenseType
          return (
            <div key={id} value={id} className={styles.licenseType} datatesting="select_input_license_type">
              <SampleLengthIcon maxSeconds={licenseType.max_seconds} />
              <div className={styles.info}>
                <p>{licenseType.description_short}</p>
                <span>Share {renderLicenseReveue(id)}% of revenue</span>
              </div>
            </div>
          )
        })}
    </Select>
  )
}

export default SelectSampleLength
